import { Panel } from './Panel'
import { mutate } from '@/runtime'
import type { PageResource } from '@/kinds/page/apply'
import { LabelsEditor } from '@/components/LabelsEditor'
import { hiddenLabel } from '@/lib/follow'

/** Labels on the page, in words with the workspace's colours; plain words to add one. */
export const LabelsPanel = ({ page }: { page: PageResource }) => (
  <Panel title="Labels">
    <LabelsEditor
      entries={Object.entries(page.labels).filter(([k]) => !hiddenLabel(k))}
      onAdd={(k, v) => void mutate.patch(page.id, { labels: { [k]: v } })}
      onRemove={(k) => void mutate.patch(page.id, { labels: { [k]: null } })}
      testid="page-label-input"
    />
  </Panel>
)
